<template>
  <div class="page-productDetails">
    <Header  path='/productCenter'></Header>
    <div class="productDetails-banner"></div>
    <div class="productDetails-describe-1"></div>
    <div class="productDetails-describe-2"></div>
    <div class="productDetails-describe-3"></div>
    <div class="productDetails-try-wrap ui-flex ui-flex-justify-center">
      <div class="productDetails-try ele-wrap ui-flex ui-flex-justify-center ui-flex-align-center">
        <span class="try-word" @click="jump('/try')">点击试用，解锁更多功能</span>
        <i class="try-icon"></i>
      </div>
    </div>
    <Footer></Footer>
  </div>

</template>
<script>
   import Header from '@/components/Header/index.vue'
  import Footer from '@/components/Footer/index.vue'
  import router from '@/router'
  export default {
    components: {
      Header,
      Footer,
    },
    data() {
      return {

        
      }
    },
    methods: {
       /**
       * 点击跳转
      */
      jump (value) {

        router.push({
          path: value,
        }).catch(err => {
          console.log(err)
        })
        

      }
    },
  }
</script>
<style lang="sass">
  @import "./style.scss"
</style>